$mol_icon_view_grid $mol_icon path \M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3
